import React from 'react'
import withCapabilities from '../../hoc/withCapabilities'
import { Box } from '@mui/material'
import { PAGE_BOTTOM_PADDING, PAGE_MAX_WIDTH, PAGE_TOP_PADDING, PAGE_WIDTH } from '../../theme'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import { useScrollToHash } from '../../hooks/useScrollToHash'
const CustomerPageTemplate: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  useScrollToHash()

  return (
    <Box>
      <Header />
      <Box
        id="main"
        sx={{
          pt: PAGE_TOP_PADDING,
          pb: PAGE_BOTTOM_PADDING,
          width: PAGE_WIDTH,
          maxWidth: PAGE_MAX_WIDTH,
          margin: '0 auto',
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  )
}

export default withCapabilities(CustomerPageTemplate)
